import { render, staticRenderFns } from "./cancellationPolicy.vue?vue&type=template&id=3c130a1a&"
import script from "./cancellationPolicy.vue?vue&type=script&lang=js&"
export * from "./cancellationPolicy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3c130a1a')) {
      api.createRecord('3c130a1a', component.options)
    } else {
      api.reload('3c130a1a', component.options)
    }
    module.hot.accept("./cancellationPolicy.vue?vue&type=template&id=3c130a1a&", function () {
      api.rerender('3c130a1a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2y614QLCoIRte/JS/cancellationPolicy.vue"
export default component.exports